/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { fetchActivityById, fetchUserById } from "../../services/activityService";
import FormattedContent from "../../components/Common/FormattedContent";
import { BASE_URL_IMAGE } from "../../config/api";
import LoadingSpinner from "../../components/Common/LoadingSpinner";
import { decrypt, encrypt } from "../../utils/encryption";
import "../../assets/css/EventDetails.css";


const ActivityDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const decryptedId = decrypt(id);

  const [activity, setActivity] = useState(null);
  const [author, setAuthor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadActivity = async () => {
      try {
        const activityData = await fetchActivityById(decryptedId);
        setActivity(activityData.data);
        // console.log(activity);

        if (activityData.data.user_id) {
          const userData = await fetchUserById(activityData.data.user_id);
          setAuthor(userData);
          // console.log(userData);
        }
      } catch (err) {
        setError("Failed to load event details.");
      } finally {
        setLoading(false);
      }
    };

    loadActivity();
  }, [decryptedId]);

  const breadcrumbItems = [
    { label: "Activity", path: "/list-activities" },
    { label: "Activity Detail" },
  ];

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  if (loading) {
    return (
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content">
            <LoadingSpinner message="Loading activity..." />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content">
            <div className="error-container">
              <h3>Error</h3>
              <p>{error}</p>
              <button className="btn btn-primary" onClick={() => navigate("/activities")}>
                Back to Activities
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!activity) {
    return null;
  }

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <Breadcrumb items={breadcrumbItems} />
          </div>

          <div className="row">
            {/* Main content */}
            <div className="col-lg-8 col-md-12">
              <div className="event-view">
                <article className="event-single-post">
                  <div className="event-header">
                    <div className="badge bg-primary">{activity.activity_mode || "Activity"}</div>
                    <h1 className="event-title">{activity.activity_title}</h1>
                    <div className="event-meta">
                      <div className="meta-item">
                        <img
                          className="author-avatar"
                          src={`${BASE_URL_IMAGE}/uploads/userProfiles/${author?.user_profile_img}`}
                          alt={author?.user_name}
                        />
                        <div className="author-info">
                          <span className="author-name">{author?.user_name || "Unknown Author"}</span>
                          <span className="author-designation">{author?.user_designation}</span>
                        </div>
                      </div>
                      <div className="meta-divider">•</div>
                      <div className="meta-item">
                        <FeatherIcon icon="calendar" size={16} />
                        <span>
                          {formatDate(activity.activity_start_date)} - {formatDate(activity.activity_end_date)}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="event-image-container">
                    <img
                      className="event-featured-image"
                      src={`${BASE_URL_IMAGE}/uploads/activityImages/${activity.activity_image}`}
                      alt={activity.activity_title}
                    />
                  </div>

                  <div className="event-content">
                    <FormattedContent htmlContent={activity.activity_content} />
                    {/* {activity.event_tags && (
                      <div className="event-tags">
                        <h5>Tags:</h5>
                        <div className="tags-container">
                          {event.event_tags.split(",").map((tag, idx) => (
                            <span key={idx} className="tag">
                              #{tag.trim()}
                            </span>
                          ))}
                        </div>
                      </div>
                    )} */}
                  </div>
                </article>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-lg-4 col-md-12">
              <div className="event-sidebar">
                {/* Author Card */}
                <div className="author-profile-card">
                  <img
                    className="profile-image-circle"
                    alt="Author"
                    src={`${BASE_URL_IMAGE}/uploads/userProfiles/${author?.user_profile_img}`}
                  />
                  <div className="profile-info">
                    <h4 className="profile-name">{author?.user_name || "Unknown Author"}</h4>
                    <p className="profile-role">{author?.user_designation}</p>
                  </div>
                </div>

                {/* Quick Actions */}
                <div className="quick-actions-widget">
                  <h5>Quick Actions</h5>
                  <div className="action-buttons">
                    <Link to="/list-activities" className="btn btn-outline-primary btn-block">
                      <FeatherIcon icon="arrow-left" size={16} className="me-2" />
                      Back to Activities
                    </Link>
                    <Link
                      to={`/edit-activity/${encodeURIComponent(encrypt(decryptedId))}`}
                      className="btn btn-primary btn-block"
                    >
                      <FeatherIcon icon="edit" size={16} className="me-2" />
                      Edit Activity
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </div >
  );
};

export default ActivityDetails;
